<template>
  <div>
    <div class="search">
      <el-date-picker
        v-model="pickVal"
        type="daterange"
        align="right"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions"
      ></el-date-picker>
      <el-select v-model="selectVal" multiple>
        <el-option v-for="i in SJJOptions" :key="i.Id" :value="i.Id" :label="i.Name"></el-option>
      </el-select>
      <el-button type="primary" @click="handleSearch">查询</el-button>
    </div>
    <el-table :data="pageList" border style="margin-top: 20px">
      <el-table-column prop="Month" label="月份" align="center"></el-table-column>
      <el-table-column prop="MonthFillRate" label="月度填充率" align="center"></el-table-column>
      <el-table-column label="操作" align="center">
        <template #default="{ row }">
          <el-button size="small" @click="handleDetail(row)">查看详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="详情" :visible.sync="visible">
      <el-table
        :header-cell-style="{
          'text-align': 'center',
          background: 'rgb(240, 247, 253)'
        }"
        border
        default-expand-all
        :data="tableData1"
        style="width: 100%"
        row-key="Id"
        lazy
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      >
        <el-table-column prop="Name" label="节点名称"></el-table-column>
        <el-table-column align="center" prop="FillRate" label="填充率" width="180"></el-table-column>
        <el-table-column align="center" prop="FillCount" label="数据同步数量"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import tree from '@/api/tree';
import { treeOptions2 } from '@/utils/dictionary.js';
import { generateNestedTree } from '@/utils/tree.js';
export default {
  name: 'YDTCL',
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
      params: {
        rows: 1000,
        page: 1,
        key: ''
      },
      SJJOptions: [],
      selectVal: '',
      pickVal: '',
      pageList: [],
      visible: false,
      tableData1: [],
      treeOptions2: treeOptions2,
      options: []
    };
  },
  methods: {
    getData() {
      tree.GetPageList(this.params).then(res => {
        // console.log("res.data", res.data.Data.rows);
        this.options = res.data.Data.rows;
        const arr = generateNestedTree(res.data.Data.rows);
        // console.log("arr", arr);
        this.SJJOptions = arr;
      });
    },
    handleSearch() {
      if (this.pickVal.length == 0) {
        this.$message.warning('请先选择时间');
        return;
      }
      console.log(this.pickVal);
      let obj = {
        StartTime: this.pickVal[0].getFullYear() + '-' + (this.pickVal[0].getMonth() + 1) + '-' + this.pickVal[0].getDate(),
        EndTime: this.pickVal[1].getFullYear() + '-' + (this.pickVal[1].getMonth() + 1) + '-' + this.pickVal[1].getDate(),
        DataSetIdlist: this.selectVal
      };
      tree.QueryDateSetFillList(obj).then(res => {
        res.data.Data.forEach(i => {
          i.DataList = generateNestedTree(i.DataList);
        });
        this.pageList = res.data.Data;
        console.log(this.pageList);
      });
    },
    handleDetail(row) {
      console.log(row.DataList);
      this.tableData1 = row.DataList;
      this.visible = true;
    },
    findItemNameById(data) {
      const item = this.options.find(item => item.Id === data);
      return item ? item.Name : '';
    }
  },
  created() {
    this.getData();
  }
};
</script>

<style lang="scss" scoped>
.search {
  & > * {
    margin-right: 20px;
  }
}
</style>
